var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-exit"},[_vm._v("\n  ¿Deseas continuar en otro momento?\n  "),_c('u',{staticClass:"action",on:{"click":_vm.handleExit}},[_vm._v("salir")])])}
var staticRenderFns = []

export { render, staticRenderFns }